import { useState } from 'react';
import { ProductMedia } from '../../../ProductTypes';

const getMediasKey = (medias: ProductMedia[]) => medias.map((media) => media.id).join(',');

const useSelectedMediaIndex = (medias: ProductMedia[]) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [previousMediasKey, setPreviousMediasKey] = useState(() => getMediasKey(medias));

  const mediasKey = getMediasKey(medias);

  if (mediasKey !== previousMediasKey) {
    setPreviousMediasKey(mediasKey);
    setSelectedIndex(0);
  }

  return { selectedIndex, setSelectedIndex };
};

export default useSelectedMediaIndex;
